import { InputPadrao, InputDatePicker, InputTelefone } from '../../../../components/Inputs'
import { InputBeneficiarioTitular, InputEmpresaParceira, InputEstadoCivil, InputGrauDependencia, InputMunicipio, InputOperadoraSaude } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup, { validaCPF, validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { ajustarDadosTelefone, buscarCep, mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'

const CadastroPaciente = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})

    const [validacao] = useState(Yup.object({
        nome: Yup.string().required().nullable().trim(),
        cpf: Yup.string().test('CPF', 'CPF inválido!', function (value) { return validaCPF(this.parent.cpf) })
            .nullable()
            .max(100).required(),
        municipio: Yup.string().nullable().required(),
        validade_carteira: Yup.string().nullable().max(200).trim()
            .test('Validade Carteira', 'Data inválida!', function (value) { return validaData(this.parent.validade_carteira) }),
        data_nascimento: Yup.string().nullable().required()
            .test('Data', 'Data inválida!', function (value) { return validaData(this.parent.data_nascimento) })

    }))
    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            { ...values },
            '/atendimento/beneficiario',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (props.modal) {
                    props.setItemSelecionado({ value: obj.id, label: obj.bene_nome })
                    props.setShow && props.setShow(false)
                }
                else {
                    if (salvarENovo) {
                        propsFormik.resetForm({})
                        manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                        setSalvando(false)
                    }
                    else {
                        props.history.push('/atendimento/beneficiario/consulta')
                    }
                }
            },
            () => setSalvando(false))
    }

    useEffect(_ => {
        if (id)
            Promise.resolve(get(`/atendimento/beneficiario/${id}`)).then(obj => {
                if (id && !obj.id)
                    props.history.push('/atendimento/beneficiario/consulta')
                setValoresIniciais(obj)
            })
        else {
            setValoresIniciais({
                nome: '',
                cpf: '',
                data_nascimento: null,
                municipio: null
            })
        }
    }, [id])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />
                                <InputPadrao label='Nome Paciente' name='nome' type='text' placeholder='Nome' obrigatorio={true}
                                    tamanho={'col-sm-12 col-lg-6 col-xl-5'} classeTooltip={props.modal && 'tooltip-input-modal'} autoFocus salvarENovo={salvarENovo} />

                                <InputBeneficiarioTitular label='Beneficiário Titular' name='beneficiario_titular' placeholder='Beneficiário Titular' propsFormik={propsFormik} tamanho={'col-sm-12 col-lg-6 col-xl-4'} />

                                <InputGrauDependencia label='Grau de Dependência' name='grau_dependencia' placeholder='Grau de Dependência' propsFormik={propsFormik} tamanho={'col-sm-12 col-lg-4 col-xl-3'} />

                                {/* <InputEmpresaParceira label='Empresa Parceira/Plano' name='empresa_parceira' placeholder='Empresa Parceira/Plano' propsFormik={propsFormik} tamanho={'col-sm-12 col-lg-4 col-xl-3'} /> */}

                                <InputPadrao mascara="111.111.111-11" tamanho={"col-sm-12 col-lg-4 col-xl-3"} obrigatorio={true}
                                    classeTooltip={props.modal && 'tooltip-input-modal'} label="CPF" name="cpf" type="text" placeholder="CPF" />

                                <InputPadrao label='RG' name='rg' type='text' placeholder='RG'
                                    tamanho={'col-sm-12 col-lg-3 col-md-6 col-xl-3'} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Data de Nascimento" name="data_nascimento" id="data_nascimento" type="text"
                                    obrigatorio={true}
                                    setarValor={value => {
                                        propsFormik.setFieldValue("data_nascimento", value)
                                        propsFormik.setFieldTouched("data_nascimento", true)
                                    }} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputEstadoCivil label="Estado Civil" name="estado_civil" placeholder="Estado Civil" propsFormik={propsFormik} tamanho={'col-sm-12 col-lg-4 col-xl-3'} />

                                <InputPadrao label='CNS' name='cns' type='text' placeholder='CNS'
                                    tamanho={'col-sm-12 col-lg-6 col-md-7 col-xl-3'} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputPadrao label='Plano de Saúde' name='plano' type='text' placeholder='Plano de Saúde'
                                    tamanho={'col-sm-12 col-xl-3 col-lg-5'} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputPadrao label='Número Carteira' name='numero_carteira' type='text' placeholder='Número Carteira'
                                    tamanho={'col-sm-12 col-xl-3 col-lg-4'} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Validade Carteira" name="validade_carteira" type="text"
                                    setarValor={value => {
                                        propsFormik.setFieldValue("validade_carteira", value)
                                    }} classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <InputPadrao
                                    mascara="11111-111"
                                    tamanho={"col-lg-2 col-sm-12 col-xl-3"}
                                    label="CEP"
                                    name="cep"
                                    type="text"
                                    placeholder="CEP" onBlur={e => buscarCep(e, propsFormik)}
                                />
                                <InputPadrao
                                    tamanho={"col-lg-4 col-sm-12"}
                                    label="Logradouro"
                                    name="logradouro"
                                    type="text"
                                    placeholder="Logradouro"
                                />
                                <InputPadrao
                                    tamanho={"col-lg-4 col-sm-12"}
                                    label="Complemento"
                                    name="complemento"
                                    type="text"
                                    placeholder="Complemento"
                                />
                                <InputPadrao
                                    tamanho={"col-lg-2 col-sm-12"}
                                    label="Número"
                                    name="numero"
                                    type="text"
                                    placeholder="Número"
                                />
                                <InputPadrao
                                    tamanho={"col-lg-2 col-sm-12"}
                                    label="Bairro"
                                    name="bairro"
                                    type="text"
                                    placeholder="Bairro"
                                />

                                <InputMunicipio
                                    tamanho={"col-lg-3 col-sm-12"}
                                    label='Município - UF'
                                    name='municipio'
                                    placeholder='Município - UF'
                                    obrigatorio={true}
                                    propsFormik={propsFormik} />

                                <InputPadrao
                                    mascaraTelefone={true}
                                    label="Telefone"
                                    name="telefone"
                                    type="text"
                                    tamanho={!!props.modal ? 'col-6' : "col-sm-12 col-lg-6 col-xl-3"}
                                    placeholder="Telefone" classeTooltip={"tooltip-input-modal"}
                                />

                                <InputPadrao
                                    mascaraTelefone={true}
                                    label="Celular"
                                    name="celular"
                                    type="text"
                                    tamanho={!!props.modal ? 'col-6' : "col-sm-12 col-lg-6 col-xl-3"}
                                    placeholder="Celular" classeTooltip={"tooltip-input-modal"}
                                />

                                <InputPadrao
                                    tamanho={"col-lg-3 col-xl-6 col-sm-12"}
                                    label="E-mail"
                                    name="email"
                                    type="text"
                                    placeholder="E-mail" classeTooltip={props.modal && 'tooltip-input-modal'} />

                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />

                            </div>
                        </div>
                    </div>
                    {!props.modal && <div className='separator mt-40 mb-5'></div>}
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {(!props.modal && !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    </div>
                </Form>)
            }}
        </Formik>
    )
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Atendimento</span>,
        () => <Link className='link-active' to={'/atendimento/beneficiario/consulta'}>Paciente</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro Paciente"} link={links} />}
        <CadastroPaciente {...props} />
    </>
    )
}
export { CadastroPaciente }
export default Cadastro